import React, {PropTypes} from 'react';

import {modeCheck} from '../../settings.js';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import Logo from '../restaurant/Logo';
import NavItems from './NavItems';
import Social from './Social';

class SideNav extends React.PureComponent {
  static propTypes = {
    children: PropTypes.object,
    city: PropTypes.string,
    country: PropTypes.string,
    lang: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    package: PropTypes.number,
    restaurant: PropTypes.string,
    social: PropTypes.object,
    view: PropTypes.string,
    wine: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.mode = modeCheck("mode");

  }

  render() {
    return (
      <div>
        <div className="side-nav-logo">
          <button className="back-btn" onClick={this.props.onClick} data-value="nav"/>
          <Logo name={this.props.name} city={this.props.city} country={this.props.country}/>
        </div>
        <NavItems restaurant={this.props.restaurant} lang={this.props.lang} wine_slug={this.props.wine}
                  view={this.props.view} mode={this.mode} package={this.props.package}/>
        {this.mode !== 'kiosk' ?
          (<Social social={this.props.social} view={this.props.view}>
            <Link className="terms-link" to={'/' + this.props.lang + '/' + this.props.restaurant +'/terms'}>
              <FormattedMessage id="terms-title">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </Link>
          </Social>)
          : null
        }
        {this.props.children}
      </div>
    );
  }
}


export default SideNav;



/** WEBPACK FOOTER **
 ** ./src/components/nav/SideNav.js
 **/